import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import ProfileCard from '../components/ProfileCard';
import { imgUrl } from '../utils/imgUrl';
import './Dashboard.css';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ religion: '', city: '', marital_status: '' });
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const fetchProfiles = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams(filters).toString();
      const res = await authService.getProfiles(params);
      setProfiles(res.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchProfiles(); }, []);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const initials = user?.profile
    ? `${user.profile.first_name?.[0] || ''}${user.profile.last_name?.[0] || ''}`
    : user?.email?.[0]?.toUpperCase();

  const handleFilter = (e) => {
    e.preventDefault();
    fetchProfiles();
  };

  return (
    <div className="dashboard-wrapper">
      {/* Navbar */}
      <nav className="dashboard-nav">
        <div className="nav-brand"><img src="/logo-icon.png" alt="" className="nav-brand-icon" /> Manthrakodi</div>
        <div className="nav-right">
          <span>Welcome, {user?.profile?.first_name || user?.email}</span>
          <button onClick={() => navigate('/interests')} className="btn-interests">💌 Interests</button>
          <button onClick={() => navigate('/shortlists')} className="btn-interests">♡ Shortlisted</button>
          <button onClick={() => navigate('/wallet')} className="btn-wallet">💰 Wallet</button>
          <div className="nav-avatar-wrapper">
            <div className="nav-avatar" onClick={() => setDropdownOpen(o => !o)}>
              {user?.profile?.profile_photo
                ? <img src={imgUrl(user.profile.profile_photo)} alt="avatar" />
                : <span>{initials}</span>
              }
            </div>
            {dropdownOpen && (
              <>
                <div className="nav-dropdown-overlay" onClick={() => setDropdownOpen(false)} />
                <div className="nav-dropdown">
                  <div className="nav-dropdown-header">
                    <div className="nav-dropdown-avatar">{initials}</div>
                    <div>
                      <p className="nav-dropdown-name">{user?.profile?.first_name} {user?.profile?.last_name}</p>
                      <p className="nav-dropdown-email">{user?.email}</p>
                    </div>
                  </div>
                  <hr />
                  <button onClick={() => { setDropdownOpen(false); navigate('/my-profile'); }}>👤 My Profile</button>
                  <button onClick={() => { setDropdownOpen(false); navigate('/edit-profile'); }}>✏️ Edit Profile</button>
                  <button onClick={handleLogout} className="logout-item">🚪 Logout</button>
                </div>
              </>
            )}
          </div>
        </div>
      </nav>

      <div className="dashboard-content">
        {/* Filters */}
        <div className="filters-bar">
          <h2>Matches for You</h2>
          <form className="filters-form" onSubmit={handleFilter}>
            <input
              placeholder="Religion"
              value={filters.religion}
              onChange={(e) => setFilters({ ...filters, religion: e.target.value })}
            />
            <input
              placeholder="City"
              value={filters.city}
              onChange={(e) => setFilters({ ...filters, city: e.target.value })}
            />
            <select
              value={filters.marital_status}
              onChange={(e) => setFilters({ ...filters, marital_status: e.target.value })}
            >
              <option value="">Marital Status</option>
              <option value="never_married">Never Married</option>
              <option value="divorced">Divorced</option>
              <option value="widowed">Widowed</option>
            </select>
            <button type="submit" className="btn-filter">Search</button>
          </form>
        </div>

        {/* Profile Grid */}
        {loading ? (
          <div className="loading">Loading profiles...</div>
        ) : profiles.length === 0 ? (
          <div className="no-profiles">No profiles found.</div>
        ) : (
          <div className="profiles-grid">
            {profiles.map((profile) => (
              <ProfileCard key={profile.id} profile={profile} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
